/**
 * Given any number of class names, filter out false values and transform into a single, React-friendly className
 *
 * @param {...*} args Any number of strings or falsy values.
 *
 * @returns {String} Returns a formatted string.
 *
 * @example
 *
 * makeClassName('foo', false && 'bar', true && 'baz')
 * // => 'foo baz'
 *
 */

export let makeClassName = (
  ...args: (string | boolean | undefined)[]
): string =>
  [...args]
    .map(className => (className === false ? null : className))
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
